// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___9JQe","errors":"Errors_errors__2VM71"};